<template>
  <div id="technology">
    <div class="table_searchbar">
      <el-row style="margin-bottom:20px">
        <el-col :span="5">
          <div class="y_table" @keydown.enter="btnSearch()">
            <span class="title y_table_span">工艺编号：</span>
            <el-input
              class="y_table_cellLogy"
              style="min-width:100px ;max-width: 220px"
              size="small"
              v-model="searchForm.technologyCode"
              maxlength="50"
              @keyup.native="$event.target.value = $event.target.value.replace(/^\s+|\s+$/gm, '')"
              placeholder="工艺编号"
            ></el-input>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="y_table" @keydown.enter="btnSearch()">
            <span class="title y_table_span">物料名称：</span>
            <el-input class="y_table_cellLogy" style="min-width:100px;max-width: 220px" size="small" v-model="searchForm.materialName" maxlength="16" placeholder="物料名称"></el-input>
          </div>
        </el-col>
        <el-col :span="5">
          <div @keydown.enter="btnSearch()" class="y_table">
            <span class="title y_table_span">物料编码：</span>
            <el-input class="y_table_cellLogy" style="min-width:100px;max-width: 220px" size="small" v-model="searchForm.materialCode" maxlength="16" placeholder="物料编码"></el-input>
          </div>
        </el-col>
        <el-col :span="5">
          <div @keydown.enter="btnSearch()" class="y_table">
            <span class="title y_table_span">默认工艺：</span>
            <el-select class="y_table_cellLogy" v-model="searchForm.isDefault" size="small" placeholder="默认工艺" style="min-width:100px;max-width: 220px" clearable>
              <el-option key="1" label="默认工艺" :value="true"></el-option>
              <el-option key="2" label="非默认工艺" :value="false"></el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="4">
          <div style="text-align:right">
            <el-button size="mini" icon="el-icon-search" type="primary" @click="btnSearch()">查询</el-button>
            <el-button size="mini" icon="el-icon-refresh" @click="clearSearch">重置</el-button>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="table_common_operbar" style="margin-bottom:20px">
      <el-row>
        <el-col style="flex:1">
          <el-button icon="el-icon-plus" type="primary" v-if="permission.btn_reworkTechnology_addReworkTechnology" size="small" @click="addWindowShow()">新增</el-button>
        </el-col>
      </el-row>
    </div>

    <el-table :header-cell-class-name="headStyle" :data="tableData" stripe width="80%" class="table_data y_Public_table" :default-sort="defaultSort" @sort-change="sortChangeEvent">
      <el-table-column prop="technologyCode" label="工艺编号" min-width="80" show-overflow-tooltip></el-table-column>
      <el-table-column prop="materialCode" label="物料编码" min-width="100" show-overflow-tooltip></el-table-column>
      <el-table-column prop="materialName" label="物料名称" min-width="100" show-overflow-tooltip></el-table-column>
      <el-table-column prop="specification" label="物料型号" min-width="90" show-overflow-tooltip></el-table-column>
      <el-table-column prop="materialType" :formatter="parseType" label="物料类型" width="80" show-overflow-tooltip></el-table-column>
      <el-table-column prop="state" :formatter="parseState" label="状态" min-width="60" show-overflow-tooltip>
        <template slot-scope="scope">
          <span :style="{ color: parseStyle(scope.row) }">{{ parseState(scope.row) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createUserName" min-width="70" label="创建者" sortable="custom"></el-table-column>
      <el-table-column prop="checkUserName" min-width="70" label="审核者" sortable="custom"></el-table-column>
      <el-table-column prop="isDefault" min-width="70" label="默认工艺" :formatter="parseTechnologyType"></el-table-column>
      <el-table-column prop="gmtModified" min-width="120" :formatter="$commonUtil.changeToDate" label="更新时间" sortable="custom" show-overflow-tooltip></el-table-column>
      <el-table-column prop="gmtCreate" min-width="120" label="创建时间" sortable="custom" :formatter="$commonUtil.changeToDate" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" fixed="right" width="190">
        <template slot-scope="scope">
          <el-button @click="checkTechnology(scope.row)" type="text" size="small" v-if="permission.btn_reworkTechnology_checkReworkTechnology && scope.row.technologyState == 0">审核</el-button>
          <el-button @click="viewTechnology(scope.row)" type="text" size="small">查看</el-button>
          <el-button @click="showEditDialog(scope.row)" type="text" size="small" v-if="permission.btn_reworkTechnology_updateReworkTechnology">编辑</el-button>
          <el-button type="text" size="small" @click="deleteTechnology(scope.row)" v-if="permission.btn_reworkTechnology_removeReworkTechnology">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="page">
      <div class="total_page">
        <span> 共{{ tableTotalPage }}条 10条/页</span>
      </div>
      <div style="margin-top:3px;text-align:right; margin-bottom:20px;" v-if="tableData.length > 0">
        <el-pagination background layout="prev, pager, next" :total="tableTotalPage" @current-change="pageChange" :current-page="tableCurrentPage"></el-pagination>
      </div>
    </div>

    <!-- 新增窗口开始 -->
    <el-dialog title="新建返工工艺" style="z-index:99999999999" :visible.sync="centerDialogVisible" width="60%" center :close-on-click-modal="false">
      <el-form :model="addForm" :rules="rules" ref="addForm">
        <el-row class="form-row" :gutter="20">
          <el-col :span="6">
            <div class="y_technology_flex">
              <span class="y_flex_Cart">工艺编号：</span>
              <el-form-item prop="technologyCode" class="y_Cart_item">
                <el-input size="small" ref="focusinput" v-model="addForm.technologyCode" maxlength="50" placeholder="工艺编号"></el-input>
              </el-form-item>
            </div>
          </el-col>

          <el-col :span="6">
            <div class="y_technology_flex">
              <span class="y_flex_Cart">物料名称：</span>
              <el-form-item class="y_Cart_item">
                <el-select
                  size="small"
                  @visible-change="changeMaterialList($event, 'materialName')"
                  remote
                  filterable
                  :remote-method="remoteMethod"
                  :loading="loading"
                  @clear="clearDate"
                  v-model="addForm.materialId"
                  clearable
                  placeholder="物料名称"
                >
                  <el-option v-for="item in materialList" :key="item.id" :label="item.materialName" :value="item.id"></el-option>
                  <div v-if="materialList.length > 48" class="search-keyword" style="text-align:center">
                    <span style="font-size:12px;color:red">只显示前50条结果，请完善搜索关键字</span>
                  </div>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="y_technology_flex ">
              <span class="y_flex_Cart">物料编码：</span>
              <el-form-item class="y_Cart_item">
                <el-select
                  @visible-change="changeMaterialList($event, 'materialCode')"
                  size="small"
                  @clear="clearDate"
                  :remote-method="remoteMethod1"
                  remote
                  filterable
                  :loading="loading"
                  clearable
                  v-model="addForm.materialId"
                  placeholder="物料编码"
                  style="width:100%;"
                >
                  <el-option v-for="item in materialList" :key="item.id" :label="item.materialCode" :value="item.id"></el-option>
                  <div v-if="materialList.length > 48" class="search-keyword" style="text-align:center">
                    <span style="font-size:12px;color:red">只显示前50条结果，请完善搜索关键字</span>
                  </div>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="y_technology_flex">
              <span class="y_flex_Cart">物料类型：</span>
              <el-form-item class="y_Cart_item">
                <el-select disabled v-model="addForm.itemType" size="small" placeholder="物料类型" style="width:100%" filterable>
                  <el-option key="0" label="产品" :value="0"></el-option>
                  <el-option key="1" label="零件" :value="1"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
        </el-row>

        <el-row class="form-row " :gutter="20">
          <el-col :span="6">
            <div class="y_technology_flex">
              <span class="y_flex_Cart">工艺路线名称：</span>
              <el-form-item prop="routeName" class="y_Cart_item">
                <el-input size="small" v-model="addForm.routeName" maxlength="50" placeholder="工艺路线名称"></el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="y_technology_flex">
              <span class="y_flex_Cart">机组：</span>
              <el-form-item prop="workshopId" class="y_Cart_item">
                <el-select v-model="addForm.workshopId" size="small" placeholder="机组" style="width:100%" filterable>
                  <el-option v-for="item in workShopList" :key="item.id" :value="item.id" :label="item.name"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="y_technology_flex y_margin">
              <span>&nbsp;</span>
              <el-form-item class="y_Cart_item">
                <el-checkbox v-model="addForm.isDefault">默认工艺</el-checkbox>
              </el-form-item>
            </div>
          </el-col>
        </el-row>

        <el-table :data="addForm.procedureList" style="width: 100%" :maxHeight="356">
          <el-table-column label="操作" width="60px">
            <template slot-scope="scope">
              <el-form-item style="display: inline-block;">
                <i class="el-icon-delete" v-if="procedureList.length > 1" style="color:red;cursor:pointer;font-size:16px;" @click="delLists(scope.$index)"></i>
                <i
                  @click="addLists(scope.$index)"
                  v-if="procedureList.length == scope.$index + 1"
                  class="el-icon-circle-plus-outline"
                  style="color:#007ACC;cursor:pointer;font-size:16px;font-weight:700"
                ></i>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="序号" min-width="80px">
            <template slot-scope="scope">
              <el-form-item :prop="`procedureList[${scope.$index}].procedureIndex`" :rules="rules.procedureIndex" style="display: inline-block;">
                <el-input :maxlength="6" v-model="scope.row.procedureIndex"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="工序编码" min-width="80px">
            <template slot-scope="scope">
              <el-form-item style="display: inline-block;">
                <el-input :maxlength="16" v-model="scope.row.procedureCode"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="工作中心编码" min-width="100px">
            <template slot-scope="scope">
              <el-form-item style="display: inline-block;">
                <el-select v-model="scope.row.factoryModelCode" @change="selectFactoryModel($event, scope)" filterable>
                  <el-option v-for="item in factoryList" :key="item.factoryCode" :label="item.factoryCode" :value="item.factoryCode"></el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="工作中心名称" min-width="100px">
            <template slot-scope="scope">
              <el-form-item style="display: inline-block;">
                <el-select v-model="scope.row.factoryModelCode" @change="selectFactoryModel($event, scope)" filterable>
                  <el-option v-for="item in factoryList" :key="item.factoryCode" :label="item.factoryName" :value="item.factoryCode"></el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="工序名称" min-width="80px">
            <template slot-scope="scope">
              <el-form-item :prop="`procedureList[${scope.$index}].procedureName`" :rules="rules.procedureName" style="display: inline-block;">
                <el-select v-model="scope.row.procedureName" filterable allow-create clearable>
                  <el-option v-for="item in scope.row.procedureNameList || []" :key="item" :label="item" :value="item"></el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="默认工价" min-width="100px">
            <template slot-scope="scope">
              <el-form-item :prop="`procedureList[${scope.$index}].everySalary`" :rules="rules.everySalary" style="display: inline-block;">
                <el-input :maxlength="9" v-model="scope.row.everySalary"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addTechnology()">确 定</el-button>
        <el-button @click="closeAdd">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 新增窗口结束 -->

    <!-- 编辑窗口开始 -->
    <el-dialog title="编辑返工工艺" style="z-index:99999999999" :visible.sync="editTechnologyDialogVisible" width="60%" center :close-on-click-modal="false">
      <el-form :model="addForm" :rules="rules" ref="editForm">
        <el-row class="form-row" :gutter="20">
          <el-col :span="6">
            <div class="y_technology_flex">
              <span class="y_flex_Cart">工艺编号：</span>
              <el-form-item prop="technologyCode" class="y_Cart_item">
                <el-input size="small" ref="focusinput" v-model="addForm.technologyCode" maxlength="50" placeholder="工艺编号"></el-input>
              </el-form-item>
            </div>
          </el-col>

          <el-col :span="6">
            <div class="y_technology_flex">
              <span class="y_flex_Cart">物料名称：</span>
              <el-form-item class="y_Cart_item">
                <el-select
                  size="small"
                  @visible-change="changeMaterialList($event, 'materialName')"
                  remote
                  filterable
                  :remote-method="remoteMethod"
                  :loading="loading"
                  @clear="clearDate"
                  v-model="addForm.materialId"
                  clearable
                  placeholder="物料名称"
                >
                  <el-option v-for="item in materialList" :key="item.id" :label="item.materialName" :value="item.id"> </el-option>
                  <div v-if="materialList.length > 48" class="search-keyword" style="text-align:center">
                    <span style="font-size:12px;color:red">只显示前50条结果，请完善搜索关键字</span>
                  </div>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="y_technology_flex ">
              <span class="y_flex_Cart">物料编码：</span>
              <el-form-item class="y_Cart_item">
                <el-select
                  @visible-change="changeMaterialList($event, 'materialCode')"
                  size="small"
                  @clear="clearDate"
                  :remote-method="remoteMethod1"
                  clearable
                  remote
                  filterable
                  :loading="loading"
                  v-model="addForm.materialId"
                  placeholder="物料编码"
                  style="width:100%;"
                >
                  <el-option v-for="item in materialList" :key="item.id" :label="item.materialCode" :value="item.id"> </el-option>
                  <div v-if="materialList.length > 48" class="search-keyword" style="text-align:center">
                    <span style="font-size:12px;color:red">只显示前50条结果，请完善搜索关键字</span>
                  </div>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="y_technology_flex">
              <span class="y_flex_Cart">物料类型：</span>
              <el-form-item class="y_Cart_item">
                <el-select disabled v-model="addForm.itemType" size="small" placeholder="物料类型" style="width:100%" filterable>
                  <el-option key="0" label="产品" :value="0"></el-option>
                  <el-option key="1" label="零件" :value="1"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
        </el-row>

        <el-row class="form-row " :gutter="20">
          <el-col :span="6">
            <div class="y_technology_flex">
              <span class="y_flex_Cart">工艺路线名称：</span>
              <el-form-item prop="routeName" class="y_Cart_item">
                <el-input size="small" v-model="addForm.routeName" maxlength="50" placeholder="工艺路线名称"></el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="y_technology_flex">
              <span class="y_flex_Cart">机组：</span>
              <el-form-item prop="workshopId" class="y_Cart_item">
                <el-select v-model="addForm.workshopId" size="small" placeholder="机组" style="width:100%" filterable>
                  <el-option v-for="item in workShopList" :key="item.id" :value="item.id" :label="item.name"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="y_technology_flex y_margin">
              <span>&nbsp;</span>
              <el-form-item class="y_Cart_item">
                <el-checkbox v-model="addForm.isDefault">默认工艺</el-checkbox>
              </el-form-item>
            </div>
          </el-col>
        </el-row>

        <el-table :data="addForm.procedureList" style="width: 100%" :maxHeight="356">
          <el-table-column label="操作" min-width="50px">
            <template slot-scope="scope">
              <el-form-item style="display: inline-block;">
                <i class="el-icon-delete" v-if="procedureList.length > 1" style="color:red;cursor:pointer;font-size:16px;" @click="delLists(scope.$index)"></i>
                <i
                  @click="addLists(scope.$index)"
                  v-if="procedureList.length == scope.$index + 1"
                  class="el-icon-circle-plus-outline"
                  style="color:#007ACC;cursor:pointer;font-size:16px;font-weight:700"
                ></i>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="序号" min-width="80px">
            <template slot-scope="scope">
              <el-form-item :prop="`procedureList[${scope.$index}].procedureIndex`" :rules="rules.procedureIndex" style="display: inline-block;">
                <el-input :maxlength="6" v-model="scope.row.procedureIndex"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="工序编码" min-width="80px">
            <template slot-scope="scope">
              <el-form-item style="display: inline-block;">
                <el-input :maxlength="16" v-model="scope.row.procedureCode"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="工作中心编码" min-width="100px">
            <template slot-scope="scope">
              <el-form-item style="display: inline-block;">
                <el-select v-model="scope.row.factoryModelCode" @change="selectFactoryModel($event, scope)" filterable>
                  <el-option v-for="item in factoryList" :key="item.factoryCode" :label="item.factoryCode" :value="item.factoryCode"></el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="工作中心名称" min-width="100px">
            <template slot-scope="scope">
              <el-form-item style="display: inline-block;">
                <el-select v-model="scope.row.factoryModelCode" @change="selectFactoryModel($event, scope)" filterable>
                  <el-option v-for="item in factoryList" :key="item.factoryCode" :label="item.factoryName" :value="item.factoryCode"></el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="工序名称" min-width="80px">
            <template slot-scope="scope">
              <el-form-item :prop="`procedureList[${scope.$index}].procedureName`" :rules="rules.procedureName" style="display: inline-block;">
                <el-select v-model="scope.row.procedureName" filterable allow-create clearable>
                  <el-option v-for="item in scope.row.procedureNameList || []" :key="item" :label="item" :value="item"></el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="默认工价" min-width="100px">
            <template slot-scope="scope">
              <el-form-item :prop="`procedureList[${scope.$index}].everySalary`" :rules="rules.everySalary" style="display: inline-block;">
                <el-input :maxlength="9" v-model="scope.row.everySalary"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
        </el-table>
      </el-form>

      <span slot="footer" class="el-dialog__footer" style="text-align: center;" center>
        <el-button type="primary" @click="updateTechnology()">确 定</el-button>
        <el-button @click="closeEdit">取消</el-button>
      </span>
    </el-dialog>
    <!-- 编辑窗口结束 -->

    <el-dialog title="查看返工工艺" style="z-index:99999999999" :visible.sync="viewTechnologyDialogVisible" width="60%" center :close-on-click-modal="false">
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="">
            <span class="key">工艺编号:</span>
            <span class="value">{{ viewForm.technologyCode }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="">
            <span class="key">物料类型:</span>
            <span class="value">{{ viewForm.itemType }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="">
            <span class="key">物料名称:</span>
            <span class="value">{{ viewForm.materialName }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="">
            <span class="key">物料编码:</span>
            <span class="value">{{ viewForm.materialCode }}</span>
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="20" style="margin-top: 30px;">
        <el-col :span="6">
          <div class="">
            <span class="key">工艺路线名称:</span>
            <span class="value">{{ viewForm.routeName }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="">
            <span class="key">机组:</span>
            <span class="value">{{ viewForm.workshopName }}</span>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="">
            <span class="key">默认工艺:</span>
            <span class="value"><el-checkbox disabled v-model="viewForm.isDefault"></el-checkbox></span>
          </div>
        </el-col>
      </el-row>
      <el-table :data="viewForm.procedureList" style="width: 100%" :maxHeight="356">
        <el-table-column label="序号" min-width="50px" prop="procedureIndex"></el-table-column>
        <el-table-column label="工序编码" min-width="80px" prop="procedureCode"></el-table-column>
        <el-table-column label="工作中心编码" min-width="100px" prop="factoryModelCode"></el-table-column>
        <el-table-column label="工作中心名称" min-width="100px" prop="factoryModelName"></el-table-column>
        <el-table-column label="工序名称" min-width="80px" prop="procedureName"></el-table-column>
        <el-table-column label="默认工价" min-width="80px" prop="everySalary"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "ReworkTechnology",
  data() {
    return {
      orderType: "DESC", //排序类型
      orderColumn: "gmtCreate", //排序列
      defaultSort: { prop: "gmtCreate", order: "descending" }, //默认排序设置
      searchCopy: {},
      fristLoad: false,
      materialOldList: [],
      materialList: [],
      loading: false,
      W: false,
      searchForm: {
        technologyCode: "",
        isDefault: null,
        materialCode: "",
        materialName: ""
      },
      procedureList: [{ procedureIndex: 1 }],
      addForm: {
        id: null,
        materialId: null,
        materialCode: null,
        materialName: null,
        itemType: null,
        technologyCode: "",
        productModel: "",
        productName: "",
        selectedProduct: {},
        selectedPart: null,
        procedureCode: "",
        procedureList: [{}],
        remark: ""
      },
      factoryList: [],
      viewForm: {
        technologyCode: "",
        productModel: "",
        productName: "",
        selectedProduct: {},
        selectedPart: null,
        remark: "",
        id: null
      },

      product: [],
      workShopList: [],

      centerDialogVisible: false,

      editTechnologyDialogVisible: false,
      viewTechnologyDialogVisible: false,
      procedureData: [],

      parameterData: [],
      tableData: [],

      dialogVisible: false,

      tableCurrentPage: 1,
      tableTotalPage: 100,
      rules: {
        technologyCode: [{ required: true, message: "请输入工艺编号", trigger: "blur" }],
        productModel: [{ required: true, message: "请选择型号", trigger: "blur" }],
        materialId: [{ required: true, message: "请选择物料编码", trigger: "blur" }],
        workshopId: [{ required: true, message: "请选择机组", trigger: "blur" }],
        procedureName: [{ required: true, message: "请输入工序名称", trigger: "blur" }],
        procedureIndex: [
          { required: true, message: "工序号不能为空", trigger: "blur" },
          {
            validator(rule, value, callback) {
              if (value) {
                if (!/^([1-9]{1}\d*)$/.test(value)) {
                  callback(new Error("工序号必须为数字"));
                } else {
                  value = Number(value);
                  if (value > 0 && Number.isInteger(value)) {
                    callback();
                  } else {
                    console.log(value);
                    callback(new Error("工序号必须为正整数"));
                  }
                }
              } else {
                callback("工序号不能为空");
              }
            },
            trigger: "blur"
          }
        ],
        everySalary: [
          {
            validator(rule, value, callback) {
              if (value) {
                if (!/^([1-9]{1}\d*)$/.test(value)) {
                  callback(new Error("默认工价必须为数字"));
                } else {
                  value = Number(value);
                  if (value > 0) {
                    if (value.toFixed(4) != value) {
                      callback(`默认工价最多可保留4位小数`);
                    } else {
                      callback();
                    }
                  } else {
                    callback(new Error("默认工价必须大于零"));
                  }
                }
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        routeName: [{ required: true, message: "请输入工艺路线名称", trigger: "blur" }],
        procedureCode: [{ required: true, message: "请输入工序编号", trigger: "blur" }]
      },
      permission: JSON.parse(localStorage.getItem("permission"))
    };
  },

  mounted: function() {
    this.initTable();
    this.loadMaterialList();
    this.loadWorkShopList();
    this.getListFactoryModel();
    let w = document.documentElement.clientWidth || document.body.clientWidth;
    w >= 1900 ? (this.W = true) : (this.W = false);
    window.onresize = () => {
      let w = document.documentElement.clientWidth || document.body.clientWidth;
      w >= 1900 ? (this.W = true) : (this.W = false);
    };
  },
  filters: {},
  methods: {
    loadWorkShopList() {
      this.$RequestUtil.get({
        url: "/api/factoryModel/getWorkShopList",
        // type:'sync',
        params: {},
        success: res => {
          if (res.code == 0) {
            this.workShopList = res.data;
          } else {
            this.$message.error(res.msg || res.message);
          }
        }
      });
    },

    // 获取工作中心下拉选项
    async getListFactoryModel(Name, Code) {
      let res = await this.$RequestUtil.getAsync({ url: "/api/select/listFactoryModel", params: { Name, Code } });
      if (res.code != 0) {
        this.$message.error(res.msg || res.message);
        return;
      }
      this.factoryList = res.data;
    },

    async selectFactoryModel(ev, scope) {
      let procedureNameList = await this.loadProcedureListByWorkCenterCode(ev);
      this.$set(scope.row, "procedureNameList", procedureNameList);
      if (!scope.row.procedureName) {
        let procedureName = (this.factoryList.find(item => item.factoryCode == ev) || {}).factoryName;
        this.$set(scope.row, "procedureName", procedureName);
      }
    },

    async loadProcedureListByWorkCenterCode(workCenterCode) {
      let { data, code, message, msg } = await this.$RequestUtil.getAsync({ url: "/api/procedureConfig/getProcedureNameByWorkCenterCode", params: { workCenterCode } });
      return data;
    },

    //父组件的方法
    //排序改变事件
    sortChangeEvent(param) {
      console.log(param);
      let orderType = param.order;
      let orderColumn = param.prop;
      this.orderColumn = orderColumn;
      if (orderType == "descending") {
        this.orderType = "DESC";
      } else if (orderType == "ascending") {
        this.orderType = "ASC";
      } else {
        this.orderType = orderType;
        this.orderColumn = null;
      }

      if (this.comebackFlag) {
        this.comebackFlag = false;
        console.log("排序", this.oldPageNum);
        if (this.oldPageNum) {
          this.tableCurrentPage = this.oldPageNum;
        }
        this.search(this.tableCurrentPage);
      } else {
        this.search(1);
      }
      this.tableCurrentPage = 1;
    },

    headStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 0) {
        return "cell1-class";
      }
      // log(row, column, rowIndex, columnIndex)
    },

    parseTechnologyType(rowData) {
      if (rowData.isDefault) {
        return "默认工艺";
      } else {
        return "非默认工艺";
      }
    },

    clearDate() {
      this.addForm.materialName = null;
      this.addForm.materialCode = null;
      this.addForm.itemType = null;
    },

    async loadMaterialList(itemType, materialName, materialCode) {
      let res = await this.$RequestUtil.getAsync({
        url: "/api/select/listMaterial",
        params: { itemType, materialCode, materialName, isTechnology: true }
      });
      if (itemType != 0 && itemType != 1 && !materialCode & !materialName) {
        this.materialOldList = res.data;
      }
      this.materialList = res.data;
      return res.data;
    },

    async changeMaterialList(ev, type) {
      if (!ev) {
        let info = null;
        if (this.addForm.materialId) {
          info = this.materialList.find(item => item.id == this.addForm.materialId);
          if (this.addForm.itemType == null || this.addForm.itemType == undefined) {
            this.$set(this.addForm, "itemType", info.itemType);
          }
        }
        let data = await this.loadMaterialList(this.addForm.itemType, null, null);
        if (info) {
          let has = data.find(item => item.id == info.id);
          if (has) {
          } else {
            this.materialList.unshift(info);
          }
        }
      }
    },

    parseStyle(rowData) {
      if (rowData.technologyState == 0) {
        return "red";
      } else {
        return "green";
      }
    },

    async remoteMethod(query) {
      this.loading = true;
      let data = await this.loadMaterialList(this.addForm.itemType, query, null);
      this.loading = false;
    },

    async remoteMethod1(query) {
      this.loading = true;
      let data = await this.loadMaterialList(this.addForm.itemType, null, query);
      this.loading = false;
    },

    reload() {
      this.initTable();
      this.$store.commit("delete_reloadPages", "/Technology");
      this.$forceUpdate();
    },

    btnSearch: function() {
      this.searchCopy = commonUtils.cloneObj(this.searchForm);
      this.tableCurrentPage = 1;
      this.search();
    },

    clearSearch() {
      let form = this.searchForm;
      form.technologyCode = "";
      form.materialCode = "";
      form.materialName = "";
      form.isDefault = null;
    },

    search: function() {
      this.$RequestUtil.loading();
      this.$RequestUtil.get({
        url: "/api/reworkTechnology/listReworkTechnology",
        type: "sync",
        params: {
          pageNum: this.tableCurrentPage,
          pageSize: 10,
          orderType: this.orderType,
          orderColumn: this.orderColumn,
          technologyCode: this.searchForm.technologyCode,
          materialCode: this.searchForm.materialCode,
          materialName: this.searchForm.materialName,
          isDefault: this.searchForm.isDefault
        },
        success: res => {
          this.$RequestUtil.loading().close();
          if (res.msg == "success") {
            this.tableData = res.data;
            this.tableTotalPage = res.totalPages;
            if (res.totalPages == 0 && this.fristLoad) {
              this.$message.warning("查询不到符合条件的数据");
            }
            this.fristLoad = true;
          } else {
            this.$message.error(res.message || res.msg);
          }
        }
      });
    },

    pageChange: function(targetPage) {
      this.$set(this, "searchForm", commonUtils.cloneObj(this.searchCopy));
      this.tableCurrentPage = targetPage;
      this.search();
    },

    initTable: function() {
      this.search();
    },

    addWindowShow: function() {
      this.centerDialogVisible = true;
      this.procedureData = [];
      this.parameterData = [];
      this.addForm = {
        id: null,
        technologyCode: "",
        workshopId: null,
        itemType: null,
        materialId: null,
        routeName: "",
        isDefault: false,
        procedureList: [{ procedureIndex: 1 }]
      };
      this.procedureList = [{ procedureIndex: 1 }];
      setTimeout(() => {
        this.$refs.focusinput.focus();
      }, 0);
    },

    addTechnology: function() {
      this.$refs["addForm"].validate(valid => {
        if (valid) {
          var technologyObject = {};
          technologyObject.technologyCode = this.addForm.technologyCode;
          technologyObject.materialId = this.addForm.materialId;
          technologyObject.routeName = this.addForm.routeName;
          technologyObject.procedureList = this.addForm.procedureList;
          technologyObject.itemType = this.addForm.itemType;
          technologyObject.isDefault = this.addForm.isDefault;
          technologyObject.workshopId = this.addForm.workshopId;
          if (this.procedureList.length == 0) {
            this.$message.error("工序不能为空，请添加工序");
            return;
          }
          this.$RequestUtil.post({
            url: "/api/reworkTechnology/addReworkTechnology",
            type: "sync",
            params: technologyObject,
            success: res => {
              if (res.code == 0) {
                this.$message({
                  type: "success",
                  message: "添加成功"
                });
                this.initTable();
                this.closeAdd();
              } else {
                this.$message({
                  type: "error",
                  message: res.msg || res.message
                });
              }
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    closeAdd() {
      this.$refs["addForm"].clearValidate();
      this.centerDialogVisible = false;
    },
    delLists(index) {
      this.addForm.procedureList.splice(index, 1);
      this.addForm.procedureList.forEach((item, i) => {
        item.index = i;
      });
      return false;
    },

    addLists() {
      let len = this.addForm.procedureList.length;
      let lastIndex = Number(this.addForm.procedureList[len - 1].procedureIndex);
      this.addForm.procedureList.push({
        procedureIndex: lastIndex + 1,
        index: len
      });
      this.procedureList = this.addForm.procedureList;
      return false;
    },

    updateTechnology: function() {
      this.$refs["editForm"].validate(valid => {
        if (valid) {
          var technologyObject = {};
          technologyObject.id = this.addForm.id;
          technologyObject.technologyCode = this.addForm.technologyCode;
          technologyObject.materialId = this.addForm.materialId;
          technologyObject.routeName = this.addForm.routeName;
          technologyObject.procedureList = this.addForm.procedureList;
          technologyObject.itemType = this.addForm.itemType;
          technologyObject.isDefault = this.addForm.isDefault;
          technologyObject.workshopId = this.addForm.workshopId;
          if (this.procedureList.length == 0) {
            this.$message.error("工序不能为空，请添加工序");
            return;
          }
          this.$RequestUtil.loading();
          this.$RequestUtil.post({
            url: "/api/reworkTechnology/updateReworkTechnology",
            // type:'sync',
            params: technologyObject,
            success: res => {
              if (res.code == 0) {
                this.$message({
                  type: "success",
                  message: "修改成功"
                });
                this.initTable();
                this.closeEdit();
              } else {
                this.$RequestUtil.loading().close();
                this.$message({
                  type: "error",
                  message: res.message
                });
              }
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    closeEdit() {
      this.$refs["editForm"].clearValidate();
      this.editTechnologyDialogVisible = false;
    },
    showEditDialog: async function(rowData) {
      this.addForm.id = rowData.id;
      this.addForm.technologyCode = rowData.technologyCode;
      this.addForm.materialId = rowData.materialId;
      this.addForm.itemType = rowData.materialType;
      this.$set(this.addForm, "isDefault", rowData.isDefault);
      if (this.addForm.materialId) {
        let json = {
          materialName: rowData.materialName,
          itemType: this.addForm.itemType,
          materialCode: rowData.materialCode,
          id: this.addForm.materialId
        };
        let find = this.materialList.find(item => item.id == this.addForm.materialId);
        if (!find) {
          this.materialList.unshift(json);
        }
      }
      let data = await this.getTechnologyDetail(rowData.id);
      this.$set(this.addForm, "routeName", data.routeName);
      this.$set(this.addForm, "workshopId", data.workshopId);
      this.addForm.procedureList = data.procedureList;
      this.procedureList = data.procedureList;
      this.editTechnologyDialogVisible = true;
    },

    async getTechnologyDetail(id) {
      let { data, code, msg, message } = await this.$RequestUtil.getAsync({ url: "/api/reworkTechnology/getReworkTechnology", type: "sync", params: { id } });
      return data;
    },

    cancalViewTechnology() {
      this.procedureData = [];
      this.parameterData = [];
      this.viewTechnologyDialogVisible = false;
    },

    viewTechnology: async function(rowData) {
      let data = await this.getTechnologyDetail(rowData.id);
      this.viewForm = commonUtils.cloneObj(data);
      this.viewForm.itemType = this.parseType(data);
      this.viewTechnologyDialogVisible = true;
    },

    deleteTechnology: function(rowData) {
      this.$confirm("此操作将删除该工艺, 是否继续?", "提示", {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$RequestUtil.post({
          url: "/api/reworkTechnology/removeReworkTechnology",
          type: "sync",
          params: {
            id: rowData.id
          },
          success: res => {
            if (res.code == 0) {
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              this.initTable();
            } else if (res.code == -1) {
              this.$message({
                type: "error",
                message: "该工艺正在使用中，不可删除!"
              });
            }
          }
        });
      });
    },

    checkTechnology: function(rowData) {
      this.$RequestUtil.post({
        url: "/api/reworkTechnology/checkReworkTechnology",
        type: "sync",
        params: {
          id: rowData.id
        },
        success: res => {
          if (res.code == 0) {
            this.$message.success("审核成功");
            log("审核成功!");
            this.initTable();
          }
        }
      });
    },

    parseState: function(val) {
      if (val.technologyState == 0) {
        return "未审核";
      } else {
        return "已审核";
      }
    },

    parseType: function(val) {
      if (val.materialType == 0) {
        return "产品";
      } else if (val.materialType == 1) {
        return "零件";
      } else if (val.materialType == 2) {
        return "原材料";
      }
    }
  },
  computed: {
    span() {
      return this.W ? 6 : 7;
    }
  },
  watch: {}
};
</script>

<style scoped>
.el-row {
  margin-bottom: 10px;

  & :last-child {
    margin-bottom: 0;
  }
}
.form-row {
  margin-bottom: 0px;
}

.bg-purple {
  background: #d3dce6;
}

.table_searchbar {
  width: 100%;
  /* height:95px; */
  margin-top: 10px;
}

.el-upload--picture-card {
  width: 40px;
  height: 40px;
}

.file-icon-container {
  width: 36px;
  height: 45px;
  margin-top: 0px;

  background-size: cover;
  position: relative;
  cursor: pointer;
}

.file-delete {
  position: absolute;
  top: -6px;
  left: 28px;
  width: 15px;
  height: 15px;
  background-image: URL("../../static/img/delete.png");
  background-size: cover;
  cursor: pointer;
}

.margin_right_140 {
  margin-right: 140px;
}

.table_container {
  border: 1px solid #e2e2e2;
  border-radius: 1%;
  overflow: hidden;
}

.table_common_operbar {
  margin-top: 4px;
}

.table_data {
  /* margin-left: 26px; */
  margin-right: 26px;
}

.page {
  display: flex;
  justify-content: flex-end;
}

.total_page {
  margin-top: 8px;
  margin-right: 26px;
  color: #606266;
  font-size: 14px;
}

.set_header_color {
  color: #303133;
}

.el-dialog__footer {
  display: flex;
  justify-content: center;
}

.el-dialog__body {
  padding-top: 0px;
}

@media screen and (max-width: 1440px) {
  .page {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 30px;
  }
}

.key {
  font-size: 16px;
  color: #c0c4cc;
  font-family: NotoSansHans-Regula;
  padding-right: 10px;
}

.value {
  font-size: 16px;
  color: #999;
  font-family: NotoSansHans-Regula;
}

.color-blue {
  color: blue;
}

.el-icon-circle-close-outline:hover {
  color: red;
}

.delete {
  width: 18px;
  height: 19px;
  background-image: url("../../../static/img/del.png");
  cursor: pointer;
  background-repeat: no-repeat;
}

.delete:hover {
  background-image: url("../../../static/img/del-hover.png");
  background-repeat: no-repeat;
}

.import_upload {
  display: inline;
}

.table_searchbar .title11 {
  color: #606266;
  font-family: NotoSansHans-Regula;
  font-size: 14px;
}

.y_inline {
  display: inline-block;
}
.y_flex {
  display: flex;
}

.y_technology_flex {
  display: flex;
}

.y_flex_title {
  width: 100px !important;
  height: 32px;
  line-height: 32px;
  text-align: right;
  /*align-self: center;*/
}

.y_flex_item {
  height: 32px;
  align-self: center;
  /*margin-left: 5px;*/
  flex: 1;
}

.y_flex_Cart {
  width: 100px !important;
  height: 32px;
  line-height: 32px;
  text-align: right;
}

.y_Cart_item {
  height: 32px;
  align-self: center;
  /*margin-left: 5px;*/
  flex: 1;
}

.y_flex_item .el-select {
  width: 100% !important;
}

.y_Cart_item .el-select {
  width: 100% !important;
}

.y_margin_left30 {
  margin-left: 30px;
}

.y_margin {
  margin-left: 28px;
}

.y_table {
  display: table;
}

/* .y_table_span {
    width: 80px !important;
    height: 31px;
    line-height: 31px;
    text-align: right;
    display: inline-block;
} */

.y_table_cellLogy {
  display: table-cell;
  width: inherit;
  /*width: 100%*/
}

.y_table_cellLogy .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  /*width: 100% !important;*/
  line-height: inherit;
}

.y_table .el-autocomplete {
  width: 100% !important;
}

.y_table_cellLogy .el-range-editor--small .el-range__icon {
  line-height: 0 !important;
  position: relative;
  top: 13px;
}

.el-col {
  padding-left: 15px;
}
</style>
<style>
.cell1-class .cell {
  margin-left: 5px;
}

.table_searchbar .el-button--mini,
.el-button--mini.is-round {
  padding: 7px 10px;
}

/*.form-row .el-input {*/
/*  max-width: 240px;*/
/*}*/

.select_width {
  width: 170px;
}

@media screen and (max-width: 1366px) {
  .test .el-input {
    width: auto !important;
    max-width: 120px;
  }

  .form-row .el-input {
    width: 100% !important;
    min-width: 80px;
  }

  #technology .el-date-editor.el-input,
  #technology .el-date-editor.el-input__inner {
    width: 176px !important;
  }

  .y_flex_item .el-select {
    width: 100% !important;
    min-width: 80px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Rework/ReworkTechnology.vue